/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Definition of a single column in a data table: how to read the value from each row and how to render it.
 */
export interface ColumnDef { 
    /**
     * Key used to look up this column\'s value in each row dictionary. For example \'site\' or \'fleet-ipah\'.
     */
    key: string;
    /**
     * Column header text shown to the user, for example \'Top operator IPAH\'.
     */
    label: string;
    /**
     * Optional plain-language explanation of the column, shown on hover when the header alone may not be self-explanatory (for example what a score or ratio means). Omitted when the label speaks for itself.
     */
    tooltip?: string | null;
    /**
     * Optional renderer hint for the cell. \'badge\' renders a coloured pill (for example a severity), \'delta-badge\' renders a Delta value, and \'sparkline\' renders an inline mini-chart from an array of values. When omitted the value is rendered as plain text.
     */
    format?: ColumnDef.FormatEnum | null;
    /**
     * Optional column width hint in pixels for the UI renderer. When set, overrides the renderer\'s automatic width heuristic.
     */
    width?: number | null;
    /**
     * Optional semantic type hint for the cell value. \'number\' renders whole numbers, \'percentage\' renders one decimal place, \'delta\' indicates a numeric change, and \'text\' renders as plain text. When omitted the UI uses its default formatting.
     */
    columnType?: ColumnDef.ColumnTypeEnum | null;
}
export namespace ColumnDef {
    export const FormatEnum = {
        Badge: 'badge',
        DeltaBadge: 'delta-badge',
        Sparkline: 'sparkline'
    } as const;
    export type FormatEnum = typeof FormatEnum[keyof typeof FormatEnum];
    export const ColumnTypeEnum = {
        Number: 'number',
        Percentage: 'percentage',
        Delta: 'delta',
        Text: 'text'
    } as const;
    export type ColumnTypeEnum = typeof ColumnTypeEnum[keyof typeof ColumnTypeEnum];
}


